<template>
  <div class="above-excel-tool">
    <v-app-bar app clipped-left color="primary" dark height="90">
      <div id="logged-out-icon-spacer" v-if="!isLoggedIn"></div>
      <v-app-bar-nav-icon @click="$emit('toggle-drawer')" v-if="isLoggedIn"></v-app-bar-nav-icon>
      <v-toolbar-title @click="clickedLogo()">
        <v-spacer></v-spacer>
        <generic-logo class="ml-2" :subdomain="subdomain" :height="logo.height" :width="logo.width" :color="logo.color" />
        <!--        <generic-logo class="ml-2" subdomain="horton" :height="logo.height" :width="logo.width" :color="logo.color" />-->
        <!--        <generic-logo class="ml-2" subdomain="krausanderson" :height="logo.height" :width="logo.width" :color="logo.color" />-->
      </v-toolbar-title>
      <v-spacer />
      <template class="mr-4" v-if="isLoggedIn">
        <!-- Task Menu-->
        <div class="mr-4">
          <v-badge :value="hasSelfTasks" :content="selfTasks.length" overlap offset-y="9" offset-x="9" color="error">
            <v-icon @click="openTasks">mdi-format-list-checkbox</v-icon>
          </v-badge>
        </div>
        <!-- Notification Menu-->
        <div class="mr-4">
          <v-menu nudge-bottom="60px" :close-on-content-click="false" style="z-index: 9999" v-model="notificationMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                v-bind="attrs"
                v-on="on"
                :value="hasNotifications"
                overlap
                :content="notifications.length"
                offset-y="9"
                offset-x="9"
                color="error"
              >
                <v-icon @click="notificationMenu = !notificationMenu">mdi-bell</v-icon>
              </v-badge>
            </template>
            <notifications-card />
          </v-menu>
        </div>
        <!-- Broker Menu-->
        <div v-if="hasBrokerageCode" class="mr-4">
          <v-menu nudge-bottom="60px" :close-on-content-click="false" style="z-index: 101">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" class="mr-1">mdi-face-agent</v-icon>
            </template>
            <v-card>
              <v-list nav dense>
                <brokerage-side-menu />
              </v-list>
            </v-card>
          </v-menu>
        </div>
        <!-- User Menu-->
        <v-menu nudge-bottom="60px" :close-on-content-click="false" style="z-index: 101">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" class="mr-1">mdi-account-circle</v-icon>
          </template>
          <v-card>
            <v-list nav dense>
              <v-subheader>User</v-subheader>
              <ferro-menu-item title="My User" icon="mdi-account-circle" :route-name="ROUTES.MANAGE_MY_USER" />
              <ferro-menu-item title="Help" icon="mdi-help-circle" :route-name="ROUTES.NEED_HELP" />
              <ferro-menu-item @click="signOut()" title="Log Out" icon="mdi-logout" :route="false" />
            </v-list>
          </v-card>
        </v-menu>
        <user-tasks-dialog :dialog.sync="showTasksDialog" />
      </template>
    </v-app-bar>
    <v-app-bar v-if="underBarLabel" app clipped-left :color="underBarColor" dark height="25" style="top: 90px">
      {{ underBarLabel }}
      <v-icon v-if="isViewerUser" small class="mr-1 ml-1">mdi-lock-outline</v-icon>
      <span v-if="isViewerUser">Read Only</span>
    </v-app-bar>
    <v-app-bar v-else-if="isViewerUser" app clipped-left color="info" height="25" style="top: 90px">
      <v-icon small class="mr-2" color="black">mdi-lock-outline</v-icon>
      <span class="text-body-2">Read Only</span>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as routeNames from '@/router/route-names'
import {
  ACCOUNT_SELECTOR,
  ADMIN_ACCOUNTS,
  ADMIN_PROSPECTS,
  COMPANY_PROFILE,
  DASHBOARD,
  LOGIN_PAGE,
  MANAGE_MY_USER,
} from '@/router/route-names'
import AuthenticatedGuard from '@/router/authenticated-guard'
import GenericLogo from '@/components/GenericLogo'
import FerroMenuItem from '@/components/sidemenu/FerroMenuItem'
import BrokerageSideMenu from '@/components/sidemenu/BrokerageSideMenu'
import UserTasksDialog from '@/components/tasks/UserTasksDialog.vue'
import NotificationsCard from '@/components/NotificationsCard.vue'
import { subDomain } from '@/components/whitelabel/white-label'

export default {
  name: 'GlobalNavigation',
  components: { GenericLogo, FerroMenuItem, BrokerageSideMenu, UserTasksDialog, NotificationsCard },
  created() {
    this.ROUTES = routeNames
    this.LOGIN_PAGE = LOGIN_PAGE
    this.COMPANY_PROFILE = COMPANY_PROFILE
    this.ADMIN_ACCOUNTS = ADMIN_ACCOUNTS
    this.ADMIN_PROSPECTS = ADMIN_PROSPECTS
    this.DASHBOARD = DASHBOARD
  },
  props: {},
  watch: {
    'getActiveAccount.accountCode': function () {
      this.initializeAccountNotifications()
    },
  },
  data() {
    return {
      drawer: false,
      logo: {
        height: 81, // 816
        width: 234, // 1056
        color: '#ffffff',
      },
      showTasksDialog: false,
      // delete below
      fav: false,
      notificationMenu: false,
    }
  },
  methods: {
    ...mapActions({
      logout: 'logout',
      setAdminAccountView: 'setAdminAccountView',
      initializeAccountNotifications: 'initializeAccountNotifications',
    }),
    openTasks() {
      this.showTasksDialog = true
    },
    clickedLogo() {
      if (this.getAccountCode) {
        this.goToDashboard(this.getAccountCode)
      } else {
        if (AuthenticatedGuard.isLoggedIn()) {
          if (AuthenticatedGuard.isAnAdmin()) {
            this.goTo(ADMIN_ACCOUNTS)
          } else {
            // Logged in, not an admin
            if (this.getAuthedAccounts.length === 1) {
              this.goToDashboard(this.getAuthedAccounts[0])
            } else {
              this.goTo(ACCOUNT_SELECTOR)
            }
          }
        } else {
          this.goTo(LOGIN_PAGE)
        }
      }
    },
    goToDashboard(accountCode) {
      this.$router
        .push({
          name: DASHBOARD,
          params: { accountId: accountCode },
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {})
    },

    goTo(page) {
      this.$router
        .push({
          name: page,
          params: { accountId: this.getAccountCode },
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {})
    },
    signOut() {
      // this.drawer = false
      this.logout()
      this.goTo(LOGIN_PAGE)
    },
    toGoProfile() {
      this.$router
        .push({
          name: MANAGE_MY_USER,
          params: { accountId: this.getAccountCode },
          // eslint-disable-next-line no-unused-vars
        })

        // eslint-disable-next-line no-unused-vars
        .catch(e => {})
    },
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser',
      getActiveAccount: 'getActiveAccount',
      getAuthedAccounts: 'getAuthedAccounts',
      getAccountTasks: 'getAccountTasks',
      isBrokerageAdmin: 'isBrokerageAdmin',
      isBrokerageUser: 'isBrokerageUser',
      getBrokerageCodes: 'getBrokerageCodes',
      notifications: 'getAccountNotifications',
      isLoggedIn: 'isLoggedIn',
      isViewerUser: 'isViewerUser'
    }),
    hasBrokerageCode() {
      return this.getBrokerageCodes.length > 0
    },
    underBarLabel() {
      // Used to identify dev/sandbox
      return process.env.VUE_APP_APP_UNDER_BAR_LABEL
    },
    underBarColor() {
      // Used to identify dev/sandbox
      return process.env.VUE_APP_APP_UNDER_BAR_LABEL_COLOR
    },
    selfTasks() {
      const tasks = this.getAccountTasks
      if (tasks && tasks.tagged) {
        return tasks.tagged
      }
      return []
    },
    hasSelfTasks() {
      return this.selfTasks && this.selfTasks.length > 0
    },
    subdomain() {
      return subDomain
    },
    isAdmin() {
      return this.getUser.isAdmin
    },
    isLoggedIn() {
      return this.getUser && this.getUser.username
    },
    getAccount() {
      return this.getActiveAccount
    },
    getAccountCode() {
      return this.getAccount.accountCode
    },
    hasNotifications() {
      return this.notifications && this.notifications.length > 0
    },
  },
}
</script>
<style scoped lang="scss">
#logged-out-icon-spacer {
  width: 56px;
}
.theme--light.v-icon {
  color: rgba($primary, 0.2);
}
// Excel tool goes up to 10. Toolsbars around excel go to 11.
.above-excel-tool {
  z-index: 12;
}
</style>
